<template>
  <div class="card-make-content">
    <!-- <ckeditor
      :editor="editor"
      v-model="editorData"
      :config="editorConfigData.editorConfig"
      style="height:0;display:none;"
    ></ckeditor>-->

    <div class="editor-wrapper" v-if="!isPreview || isDownload">
      <div class="card-tool">
        <div class="custom-row">
          <div class="custom-col" style="margin-right: 8px;cursor: pointer" @click="backHome">
            <div class="el-icon-arrow-left" style="font-size: 20px"></div>
          </div>
          <div class="custom-col" style="margin-top: 0;">
            <!-- <div class="custom-tge green" style="width: 68px">自制</div> -->
            <div
              class="custom-tge green"
              style="width:78px; margin-left: 18px;"
              v-if="answerSheet.acCardDJType === 0"
            >自制</div>
            <div class="custom-tge yellow" style="width:78px; margin-left: 18px;" v-else-if="answerSheet.acCardDJType === 1">组卷</div>
            <div class="custom-tge green" style="width:78px; margin-left: 18px;" v-else-if="answerSheet.acCardDJType === 2">试卷导入</div>
            <!-- <div style="padding-top: 5px">
              答题卡ID：{{ answerSheet.acCardCardID }}
            </div> -->
            <div style="padding-top: 10px;cursor: pointer;font-size: 16px" @click="backHome">
            </div>
          </div>

          <div class="custom-col">
            <div class="submit-text" style="top: -8px" @click="handleSave">
              <p>
                <img
                  src="@/assets/images/tool-icon-1.png"
                  style="height: 16px"
                />
              </p>
              <p>{{ saveText }}</p>
            </div>
          </div>
          <div class="custom-col">
            <div
              class="submit-text"
              style="display: inline-block"
              @click="handlePreview"
            >
              <p class="el-icon-view" style="font-size: 20px"></p>
              <p>预览</p>
            </div>
          </div>
          <div class="custom-col">
            <div
              class="submit-text"
              style="display: inline-block"
              @click="downloadPdf"
            >
              <p class="el-icon-download" style="font-size: 20px"></p>
              <p>下载</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card-make-box" v-loading="false">
        <div class="bd-ri">
          <!-- <div class="disabled_mask" v-if="answerSheet.acCardDJType"></div> -->
          <Functional />
        </div>
        <div class="bd-le">
          <!-- AB卷切换按钮 -->
          <!-- <div class="fix-box">
          <div>
            <el-button type="primary" round style="width:110px;padding-right:10px;" v-if="isA">A卷</el-button>
            <el-button round style="width:110px;padding-right:10px;" v-else>A卷</el-button>
          </div>
          <div>
            <el-button type="primary" round style="width:110px;padding-right:10px;" v-if="isB">B卷</el-button>
            <el-button round style="width:110px;padding-right:10px;" v-else>B卷</el-button>
          </div>
          </div>-->
          <!-- AB卷切换按钮end -->
          <!-- 答题卡制作区 -->
          <div v-show="isNormal" class="message-box">
            <div class="message-con">
              为保证最佳的编辑效果，请将浏览器缩放还原为100%!（快捷键Ctrl+0）
            </div>
          </div>
          <div class="card-content">
            <template v-if="pageCell.length > 0">
              <div
                v-for="(page, pageIndex) in pageCell"
                :key="'page' + pageIndex"
                class="page-cell"
                @mousedown="handlePageCellClick(pageIndex)"
                :style="{
                  width: `${page.layout.width}px`,
                  height: `${page.layout.height}px`,
                  position: page.layout.position,
                  left: page.layout.left,
                  top: `${page.layout.top}px`,
                  'margin-left': `${page.layout.marginLeft}px`,
                  padding: page.layout.padding,
                }"
              >
                <div v-if="pageIndex == 0" class="ab-box">
                  <div
                    v-if="answerSheet.acCardABSet"
                    class="a-b basics-card-tips"
                  >
                    <div class="AB_wrapper">
                      <p class="mt">
                        <span class="c-t c-b c-b0"></span>
                        <span class="c-t no-margin">A卷</span>
                      </p>
                      <p class="mt">
                      <span class="c-t c-b c-b1"></span>
                      <span class="c-t no-margin">B卷</span>
                      </p>
                      <!-- <br /> -->
                      <!-- <br /> -->
                    </div>
                  </div>
                  <div
                    class="card-name"
                    :style="{ width: answerSheet.acCardABSet ? '86%' : '100%' }"
                  >
                    <!-- <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入答题卡标题"
                      v-model="answerSheet.acCardName"
                      maxlength="50"
                      show-word-limit
                      resize="none"
                    ></el-input> -->
                    <vue-ueditor-wrap
                      class="vue-ueditor-wrap"
                      :destroy="true"
                      id="myeditor"
                      mode="listener"
                      @ready="ready"
                      v-model="answerSheet.acCardNameFunctional"
                      :config="UEDITOR_CONFIG_TITLE"
                    ></vue-ueditor-wrap>
                  </div>
                </div>

                <p
                  v-if="pageIndex == 0 && !answerSheet.acCardHideOrCode"
                  class="code-info"
                >
                  <img src="@/assets/images/erweima.png" width="47" />
                  <span class="appTitle">扫码关注错题</span>
                </p>
                <Basics v-if="showBasics(pageIndex)" :msg="{pageIndex: pageIndex}"/>
                <div
                  class="wrapper-content"
                  :style="{ height: page.contentHeight + 'px' }"
                >
                  <!-- <div id="div1" @click="xx">adfadsf</div> -->
                  <template v-for="(obj, index) in page.fillTopiclist">
                    <div
                      class="topic-wrapper"
                      :key="index"
                      @click="handleTopicWrapperClick(index)"
                    >
                      <fill-topic
                        v-if="obj.type === 1"
                        :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }"
                        :key="'cont' + index"
                      />
                      <objective-topic
                        v-if="obj.type === 2"
                        :msg="{
                          ...obj,
                          types: 1,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }"
                        :key="'obj' + index"
                      />
                      <answer-topic
                        v-if="obj.type === 3"
                        :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }"
                        :key="'obj' + index"
                      />
                      <writing-en-topic
                        v-if="obj.type === 4"
                        :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }"
                        :key="'obj' + index"
                      />
                      <writing-topic
                        v-if="obj.type === 5"
                        :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }"
                        :key="'obj' + index"
                      />
                      <choose-topic
                        v-if="obj.type == 6"
                        :msg="{
                          ...obj,
                          pageIndex: pageIndex,
                          currentIndexInPage: index,
                        }"
                        :key="'obj' + index"
                      />
                    </div>
                  </template>
                  <div id="test-obj-group" class="obj-group"></div>
                </div>
                <div
                  class="page-num"
                  style="
                    width: 100%;
                    text-align: center;
                    position: absolute;
                    left: 0;
                    bottom: 36px;
                  "
                >
                  -{{ pageIndex + 1 }}-
                </div>
              </div>
            </template>
          </div>
          <!-- 答题卡制作区end -->
        </div>
      </div>
    </div>
    <div
      class="preview-wrapper"
      :class="{ 'hide-score': !!answerSheet.acCardHideScore }"
    >
      <div v-if="isPreview || isDownload">
        <div class="close el-icon-error" @click="handlePreviewClose(true)"></div>
        <!-- 答题卡预览区 -->
        <div id="preview-page-wrap">
          <preview-wrapper :is-preview="isPreview"></preview-wrapper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JQ from "jquery";
import VueUeditorWrap from "vue-ueditor-wrap";
import { Base64 } from "@/assets/js/base64N";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Functional from "@/components/Functional";
import { UEDITOR_CONFIG_TITLE } from "@/subjects/constant";
import Basics from "@/components/TopicMakeBox/BasicsCardBox";
import FillTopic from "@/components/TopicShow/FillTopic";
import ObjectiveTopic from "@/components/TopicShow/ObjectiveTopic1";

// import AnswerTopic from "@/components/TopicShow/AnswerTopic";
import ChooseTopic from "@/components/TopicShow/ChooseTopic1";
import AnswerTopic from "@/components/TopicShow/AnswerTopic1";
import WritingEnTopic from "@/components/TopicShow/WritingEnTopic1";
import WritingTopic from "@/components/TopicShow/WritingTopic1";
// import "@ckeditor/ckeditor5-build-inline/build/translations/zh-cn";

import cardOperate from "@/assets/js/utils/cardOperate";
console.log(cardOperate, "cardOperate");

import services from "@/services/other";
import makeCard from "../services/makeCard";
import JsPDF from "jspdf";
import { BlankModel } from "../subjects/blank/Blank.model";
import { ObjectiveModel } from "../subjects/objective/Objective.model";
import { AnswerModel } from "../subjects/answer/Answer.model";
import { WriteEnModel } from "../subjects/writeEn/WriteEn.model";
import { WriteModel } from "../subjects/write/Write.model";
import { ChooseModel } from "../subjects/choose/Choose.model";
import MyPage from "@/subjects/Page";
import { DEFAULT_PAGECELL, THS, THSObj } from "@/subjects/constant";
import { Loading } from "element-ui";
import JsBarcode from "jsbarcode";
import PreviewWrapper from "@/views/PreviewWrapper";
import { studentMsgEffect, winZoom } from "@/utils/common";
import { transformSubjects } from '@/assets/js/utils/base/parseJson'
import { stringifyJsonForSubjects } from '@/assets/js/utils/base/stringifyJson'
// 用来恢复json序列化的对象方法
const SUBJECTS_TYPE_MAP = {
  1: BlankModel,
  2: ObjectiveModel,
  3: AnswerModel,
  4: WriteEnModel,
  5: WriteModel,
  6: ChooseModel,
};

export default {
  name: "CardMake",
  components: {
    Functional,
    Basics,
    ObjectiveTopic, // 客观题组件
    FillTopic, // 填空题组件
    AnswerTopic, // 解答题组件
    ChooseTopic,
    WritingEnTopic,
    WritingTopic,
    PreviewWrapper,
    VueUeditorWrap,
  },
  computed: {
    UEDITOR_CONFIG_TITLE() {
      return UEDITOR_CONFIG_TITLE;
    },
    // ...mapState("cardMake", {
    //   answerSheet: (state) => state.answerSheet,
    // }),
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("card", {
      pageCell: (state) => state.pageCell, //纸张的数据
      subjects: (state) => state.subjects, //纸张的数据
      pageCellCopy: (state) => state.pageCellCopy, //纸张的数据
      THS: (state) => state.THS, //小题题号
      pageCellString: (state) => state.pageCellString,
      basicsCheckList: (state) => state.basicsCheckList,
    }),
    // cardName:{
    //   get:acCardName(){
    //     return this.answerSheet.acCardName
    //   },
    //   set:function(newV){
    //     this.answerSheetMut({acCardName:newV})
    //   }
    // }
  },
  data() {
    return {
      isDownload: false,
      isA: true,
      isB: false,
      localityPageCellData: [], //第一次加载的整栏所有数据
      isPreview: false,
      editor: null,
      editorData: "",
      cardName: "",
      isNormal: false,
      frequentSave: false,
      saveText: "保存",
      acCardQuestTh: [],
      acCardCardID: '',
      toolbarClicked: false,
      acCardName: '',
      editorInstance: undefined,
    };
  },
  created() {
    // this.editor = this.$ckEditor;
    // this.cardName = this.answerSheet.acCardName;
  },
  mounted() {
    this.showWindowZoomMessage();
    window.onresize = () => {
      this.showWindowZoomMessage();
    };
    // this.pageCell();
    // this.reloadPageCell();
    const { guid } = this.$route.query;
    this.setPageCell(DEFAULT_PAGECELL);
    this.setSubjects([]);
    this.setTHS(THS);
    this.fetchCardDetail(guid);
    this.addListenerBackAction();
  },
  beforeDestroy() {
    sessionStorage.setItem("pageCell", null);
    sessionStorage.setItem("subjects", null);
    // 监听浏览器按键销毁
    document.onkeydown = null;
  },
  methods: {
    ready(editorInstance) {
      this.editorInstance = editorInstance;
      const myeditor = document.getElementById(editorInstance.key);
      const toolbar = myeditor.querySelector(".edui-editor-toolbarbox");
      toolbar.onclick = () => {
        this.toolbarClicked = true;
      };
      this.showToolbarWhenFocus(editorInstance,toolbar);
      this.hideToolbarWhenFocus(editorInstance,toolbar);
      this.limitEditorEnter(editorInstance);
      const timer = setTimeout(() => {
        let myeditorNew = document.getElementById(editorInstance.key);
        this.showWheel(myeditorNew);
        clearTimeout(timer);
      }, 1000)
    },
    /**
     * 监听浏览器按键
     */
    addListenerBackAction() {
      document.onkeydown = (e) => {
        e = e ? e : window.event;
        const tagName = e.srcElement && e.srcElement.nodeName;
        if(tagName != 'INPUT' && tagName != 'TEXTAREA') {
          const keyCode = e.switch ? e.which : e.keyCode; // e.switch兼容火狐浏览器的键盘
          if(keyCode == 8) {
            return false;
          }
        } 
      }
    },
    showToolbarWhenFocus(editorInstance,toolbar) {
     editorInstance.addListener("focus", (editor) => {
        toolbar && (toolbar.style.display = "block");
        this.toolbarClicked = false;
      });
    },
    hideToolbarWhenFocus(editorInstance,toolbar) {
     editorInstance.addListener("blur", (editor) => {
        setTimeout(() => {
          !this.toolbarClicked && toolbar && (toolbar.style.display = "none");
        },200);
      });
    },
    /**
     * 当标题的内容大于等于2行的时候 限制回车
     */
    limitEditorEnter(editorInstance) {
      editorInstance.addListener("keydown",  (type, event) => {
        console.log(' => ', event.target,2, event.target.childNodes);
        const nodes = event.target.childNodes;
        if (event.which == 13 && nodes.length >= 2) {
          event.cancelBubble = true;
          event.preventDefault();
          event.stopPropagation();
        }
      })
    },

    showWheel(myeditor) {
      // 显示滚动条
      try{
      const iframe = myeditor.querySelector('.edui-editor-iframeholder') && myeditor.querySelector('.edui-editor-iframeholder').querySelector('iframe');
      iframe.contentWindow.document.body && iframe.contentWindow.document.body.style && (iframe.contentWindow.document.body.style.overflow = 'auto');
      } catch(e) {
        console.error('showWheel方法报错', e.message);
      }
    },
    
    //显示考生信息
    showBasics(pageIndex) {
      let showBasics = false;
      const { acCardPanes, acCardPint } = this.answerSheet;
      if (pageIndex === 0) {
        return true;
      }
      if (acCardPanes === 1) {
        // 一栏
        if (acCardPint == 1) {
          // 单面打印
          return true;
        } else if (acCardPint == 2) {
          // 双面打印
          return (pageIndex + 1) % 2 == 1 ? true : false;
        }
      } else if (acCardPanes === 2) {
        // 二栏
        if (acCardPint == 1) {
          // 单面打印
          return (pageIndex + 1) % 2 == 1 ? true : false;
        } else if (acCardPint == 2) {
          // 双面打印
          return (pageIndex + 1) % 4 == 1 ? true : false;
        }
      } else {
        // 三栏
        if (acCardPint == 1) {
          // 单面打印
          return (pageIndex + 1) % 3 == 1 ? true : false;
        } else if (acCardPint == 2) {
          // 双面打印
          return (pageIndex + 1) % 6 == 1 ? true : false;
        }
      }
    },
    /**
     * 单双面打印重新整理布局
     */
    resetLayoutByAcCardPint() {},
    ...mapActions({
      answerSheetAction: "answerPanel/answerSheetAction",
    }),
    fetchAddCard(guid, from) {
      document.querySelector(".preview-wrapper").style.opacity = 0;
      document.querySelector(".preview-wrapper").style.zIndex = -1;
      this.isPreview = true;
      this.resetPosition(this.answerSheet);
      this.isDownload = true;
      let timer1 = setTimeout(() => {
        if (this.saveText != "保存") {
          this.$message({
            message: "未响应,请重试!",
            type: "warning",
          });
          this.saveText = "保存";
        }
        clearTimeout(timer1);
      }, 8000);
      let timer = setTimeout(async () => {
        const pdfDom = document.querySelector("#preview-page-wrap");
        //将store中的subjects转换成acCardQuestTh原始的数据格式，为了给后端存储
        const acCardQuestTh = stringifyJsonForSubjects(this.acCardQuestTh,{guid:guid}) || [];
        const delGuid = this.getDelGuid(this.acCardQuestTh);
        const addCardParam = {
          delGuid: delGuid.join(','),
          acCard: {
            acCardGuid: guid,
            acCardCardID: this.acCardCardID,
            ...this.answerSheet,
            acCardName:this.answerSheet.acCardName&& this.answerSheet.acCardName.replace(/\s+/g, ""),
          },
          acCardCoordinate: [],
          acCardQuestTh: acCardQuestTh,
          acQuestType: [],
          acCardHtml: {
            // CardHtmlGuid: "",
            all: pdfDom.innerHTML,
            abType: 0,
            designText: JSON.stringify({
              pageCell: this.pageCell,
              subjects: this.subjects,
              // 已经添加的题号列表
              THList: this.THS,
              acCardNameFunctional: this.answerSheet.acCardNameFunctional,
              basicsCheckList: this.basicsCheckList    
            }),
          },
        };
        try {
          let result = await makeCard.addCard(addCardParam);
          if (result.status != 200) {
            this.saveText = "保存";
          } else {
            // this.$message({
            //   message: "操作成功~",
            //   type: "success",
            // });
            if (from == "download") {
              this.downloadPdfAction();
            } else {
              // 保存成功需要重新刷新下fetchCardDetail接口 为了获取acCardQuestTh 更新acCardQuestTh以便删除大提操作及时比对更新
              this.getDetailAcCard(guid);
              this.$alert("保存答题卡成功", "提示", {
                confirmButtonText: "确定",
              });
            }
            this.saveText = "保存";
          }
          clearTimeout(timer);
          clearTimeout(timer1);
        } catch (e) {
          this.saveText = "保存";
          clearTimeout(timer1);
        }
      }, 800);
    },
    // 获取删除的大题型guid
    getDelGuid(roughcastSubjects) {
    const delThs = roughcastSubjects.filter((item, index) => {
        return item.questTh != (this.subjects[index] && this.subjects[index].th)
      }).map((item) => {
        return item.questTh_Guid;
      })
      return delThs;
    },
    async getDetailAcCard(acCardGuid) {
      let { data } = await makeCard.getDetailAcCard({
        acCardGuid: acCardGuid,
        abType: 0,
      });
      if(data) {
        let { acCard, acCardHtml, acCardQuestTh, acQuestType } = data;
       this.acCardQuestTh = acCardQuestTh || []; //自制答题卡 除了第一次新增之后 每次修改大题题型都需要acCardQuestTh中的questTh_Guid
       this.acCardCardID = acCard.acCardCardID || '';
      }
      return data || {};
    },
    async fetchCardDetail(acCardGuid) {
      const data = await this.getDetailAcCard(acCardGuid);
      let { acCard, acCardHtml, acCardQuestTh, acQuestType } = data;
      if(acCard && (acCard.acCardDJType == 0 || acCard.acCardDJType == 2)) {
        // 自制
        this.answerSheetAction({
          ...acCard,
          acCardNameFunctional: acCard.acCardName
        });
        if (!acCardHtml.designText) {
          // 这里存在扫描题卷情况 先判断有没有designtext字段 没有再判断acCardQuestTh 都没有才能生成空的答题卷
          if(Array.isArray(acCardQuestTh) && acCardQuestTh.length) {
            this.createPageCellByZj(acCard,acCardQuestTh,acQuestType);
          } else {
            this.setPageCell(DEFAULT_PAGECELL);
            this.setSubjects([]);
            this.setTHS(THS);
            this.resetPageCell({
              acCardPanes: acCard.acCardPanes,
            }); 
          }
          return;
        }
        studentMsgEffect();
        const designText = JSON.parse(acCardHtml.designText)
        if (Array.isArray(designText)) {
          this.setPageCell(designText);
          this.setTHS(THS);
        } else {
          const { pageCell, subjects, THList,acCardNameFunctional,basicsCheckList } = designText;
          this.renderPageByDesignTxt(designText);
        }
     } else {
       // 如果是组卷第一次直接读组卷 第二次读保存的html 
        if (acCardHtml && acCardHtml.designText) {
          const designText = JSON.parse(acCardHtml.designText)
          this.renderPageByDesignTxt(designText);
          this.answerSheetAction({
            ...acCard,
          });
        } else {
          this.createPageCellByZj(acCard,acCardQuestTh,acQuestType);
          this.answerSheetAction({
            ...acCard,
            acCardNameFunctional: acCard && acCard.acCardName
          });
        }
      }
   
    },
    renderPageByDesignTxt(designText) {
      const { pageCell, subjects, THList,acCardNameFunctional,basicsCheckList } = designText;
      acCardNameFunctional && this.answerSheetAction({
        acCardNameFunctional: acCardNameFunctional,
        });
        basicsCheckList && this.setBasicsCheckList(basicsCheckList);
        subjects && subjects.forEach((subject) => {
        Object.setPrototypeOf(
          subject,
          SUBJECTS_TYPE_MAP[subject.type].prototype
        );
        Object.setPrototypeOf(subject.page, MyPage.prototype);
      });
      this.setPageCell(pageCell|| '');
      this.setSubjects(subjects || []);
      console.log("fetchCardDetail", designText, this.subjects);
      const sortTHS = [...new Set(THList)].sort((a, b) => {
        return THSObj[a] - THSObj[b];
      });
      this.setTHS(sortTHS);
    },
    createPageCellByZj(acCard,acCardQuestTh,acQuestType) {
      // 组卷
      this.answerSheetAction(acCard);
      const resultSubjects = transformSubjects(acCardQuestTh, acQuestType, {
      BlankModel,
      AnswerModel,
      WriteEnModel,
      WriteModel,
      ChooseModel,
      ObjectiveModel
      });
      this.setSubjects(resultSubjects);
      this.resetPageCell({
      acCardPanes: this.answerSheet.acCardPanes,
      index: 0,
      }); 
    },
    ...mapMutations({
      setCurrentPageNum: "card/setCurrentPageNum",
      resetPosition: "card/resetPosition",
      returnPosition: "card/returnPosition",
      restorePageCell: "card/restorePageCell",
      setPageCell: "card/setPageCell",
      setSubjects: "card/setSubjects",
      resetPageCell: "card/resetPageCell",
      setTHS: "card/setTHS",
      setPageCellString: "card/setPageCellString",
      setBasicsCheckList: "card/setBasicsCheckList",
    }),
    reloadPageCell() {
      const restorePageCell = JSON.parse(sessionStorage.getItem("pageCell"));
      const subjects = JSON.parse(sessionStorage.getItem("subjects"));
      this.restorePageCell({
        pageCell: restorePageCell,
        subjects: subjects,
      });
    },
    showWindowZoomMessage() {
      const per = winZoom();
      this.isNormal = per !== 100;
    },
    previewPage() {
      this.isPreview = true;
    },
    backHome() {
      this.$confirm(
        "此操作将返回到列表页，编辑的答题卡如果未保存将会丢失, 是否继续?！",
        "提示",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }
      ).then(() => {
        this.$router.push({ path: "/" });
      });
    },
    handleTopicWrapperClick(index) {},
    // 保存
    handleSave(from) {
      if (this.frequentSave) {
        return;
      }
      this.saveText = "正在保存..";
      this.frequentSave = true;
      let saveTimer = setTimeout(() => {
        // sessionStorage.setItem("pageCell", JSON.stringify(this.pageCell));
        // sessionStorage.setItem("subjects", JSON.stringify(this.subjects));
        this.frequentSave = false;
        const { guid } = this.$route.query;
        // 这里用定时器的原因是，富文本编辑器失焦才会保存数据，用户如果编辑完直接点击预览，数据不能及时保存
        const timer = setTimeout(() => {
          this.answerSheet.acCardName
            ? this.fetchAddCard(guid, from)
            : this.warningAlert();
          clearTimeout(timer);
        }, 200);
        clearTimeout(saveTimer);
      }, 1000);
    },
    warningAlert() {
      this.saveText = "保存";
      this.$message({
        message: "请输入答题卡名称",
        type: "warning",
      });
    },
    //预览
    handlePreview() {
      // 这里用定时器的原因是，富文本编辑器失焦才会保存数据，用户如果编辑完直接点击预览，数据不能及时保存
      let timer = setTimeout(() => {
        document.querySelector(".preview-wrapper").style.opacity = 1;
        document.querySelector(".preview-wrapper").style.zIndex = 200000;
        // document.querySelector(".preview-wrapper").style.fontFamily = '"Helvetica Neue",Helvetica,Arial,sans-serif'
        this.isPreview = true;
        studentMsgEffect();
        this.resetPosition(this.answerSheet);
        this.setPageCellString(JSON.stringify(this.pageCell));
        // JsBarcode("#barcode", "Hi");
        // 条形码
        // JsBarcode("#barcode", "1234", {
        //   format: "pharmacode",
        //   lineColor: "#000",
        //   width: 10,
        //   height: 50,
        //   displayValue: false,
        // });
        clearTimeout(timer);
      }, 800);
    },
    downloadPdf() {
      this.$confirm("是否保存当前答题卡并下载?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const timer = setTimeout(() => {
            this.handleSave("download");
            clearTimeout(timer);
          }, 1500);
        })
        .catch(() => {});
    },
    downloadPdfAction() {
      this.$message({
        dangerouslyUseHTMLString: true,
        message: "<strong>生成答题卡PDF中,请稍后......</strong>",
        duration: 0,
      });
      // 因为html2Canvas不能将隐藏的元素保存下来 所以要先显示然后将元素opacity置为0
      this.isDownload = true;
      studentMsgEffect();
      const timer = setTimeout(() => {
        // this.handlePreview();
        document.querySelector(".preview-wrapper").style.opacity = 1;
        document.querySelector(".preview-wrapper").style.zIndex = 200000;
        this.isPreview = true;
        this.resetPosition(this.answerSheet);
        document.querySelector(".preview-wrapper").style.zIndex = -1;
        let myPdfDom = document.querySelector("#preview-page");
        this.getPdf(myPdfDom)
          .then((canvas) => {
            let contentWidth = canvas.width;
            let contentHeight = canvas.height;
            if (this.answerSheet.acCardPanes === 1) {
              this.savePdfA4(canvas, contentWidth, contentHeight);
            } else {
              this.savePdfA3(canvas, contentWidth, contentHeight);
            }
            this.$message.closeAll();
            this.handlePreviewClose();
            this.$message({
              message: "操作成功~",
              type: "success",
            });
          })
          .catch((e) => {
          })
          .then(() => {
            this.isDownload = true;
            this.$message.closeAll();
          });
        clearTimeout(timer);
      }, 100);
    },
    savePdfA4(canvas, contentWidth, contentHeight) {
      let pageHeight = (contentWidth / 595.28) * 841.89;
      let leftHeight = contentHeight;
      let position = 0;
      let imgWidth = 595.28;
      let imgHeight = (602 / contentWidth) * contentHeight;
      let pageData = canvas.toDataURL("image/jpeg", 1.0);
      let PDF = new JsPDF("", "pt", "a4");
      if (leftHeight < pageHeight) {
        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
      } else {
        while (leftHeight > 0) {
          PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 841.89;
          // 每页会多出17点多的长度 所以拿18乘以页数
          if (leftHeight > parseInt(contentHeight / pageHeight) * 18) {
            PDF.addPage();
          }
        }
      }
      var title = this.answerSheet.acCardName;
      PDF.save(title + ".pdf");
    },
    savePdfA3(canvas, contentWidth, contentHeight) {
      let pageHeight = (contentWidth / 1191) * 842;
      let leftHeight = contentHeight;
      let position = 0;
      let imgWidth = 1191;
      let imgHeight =
        ((this.answerSheet.acCardPanes === 2 ? 1200 : 1355) / contentWidth) *
        contentHeight;
      let pageData = canvas.toDataURL("image/jpeg", 1.0);
      let PDF = new JsPDF("l", "pt", "a3");
      if (leftHeight < pageHeight) {
        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
      } else {
        const pageLen =
          parseInt(contentHeight / pageHeight) *
          (this.answerSheet.acCardPanes === 2 ? 21 : 0);
        while (leftHeight > 0) {
          PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 842;
          if (leftHeight > pageLen) {
            PDF.addPage();
          }
        }
      }
      var title = this.answerSheet.acCardName;
      PDF.save(title + ".pdf");
    },
    handlePreviewClose(fromCloseBtn) {
      this.isPreview = false;
      document.querySelector(".preview-wrapper").style.zIndex = -1;
      fromCloseBtn && this.setPageCell(this.pageCellString);
       // this.returnPosition();
    },
    // previewClose() {
    //   this.isPreview = false;
    // },
    pxDpi() {
      //1栏2栏210*297（180*257）left:15mm,3栏146*297（124*257）left:20mm
      //mm转PX公式px=(mm/25.4)*dip(96)
      //px/dip=英寸，英寸*25.4=mm
      let arrDPI = new Array();
      if (window.screen.deviceXDPI != undefined) {
        arrDPI[0] = window.screen.deviceXDPI;
        arrDPI[1] = window.screen.deviceYDPI;
      } else {
        let tmpNode = document.createElement("DIV");
        tmpNode.style.cssText =
          "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
        document.body.appendChild(tmpNode);
        arrDPI[0] = parseInt(tmpNode.offsetWidth);
        arrDPI[1] = parseInt(tmpNode.offsetHeight);
        tmpNode.parentNode.removeChild(tmpNode);
      }
      return arrDPI;
    }, //待用

    // 设置当前鼠标所在page下标到全局
    handlePageCellClick(index) {
      this.setCurrentPageNum(index);
    },
  },
  watch: {
    'answerSheet.acCardName'(newVal) {
    }
  },
};
</script>

<style lang="scss">
.card-make-content {
  textarea {
    resize: none !important;
  }
  .ab-box {
    overflow: hidden;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    .a-b {
      border: none;
      /*border: 1px solid #000;*/
      float: left;
      /*height: 66px;*/
      width: 10%;
      margin-right: 8px;
      /*.c-b0 {*/
      /*  background: #000;*/
      /*}*/
      .no-margin {
        margin-right: 0;
        margin-left: 0;
      }
      .mt {
        margin-bottom: 5px;
      }
    }
    .AB_wrapper{
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  .input-name {
    width: 70%;
  }

  .ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label {
    width: 3em;
  }
  .topic-bd {
    padding: 0 15px !important;
    .fill-cont {
      overflow: visible;
    }
  }
  .message-box {
    width: 100%;
    .message-con {
      position: fixed;
      top: 62px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      margin: 0 auto;
      font-size: 16px;
      width: 540px;
      color: #f00;
      border: 1px solid #f00;
      z-index: 9;
    }
  }
  .code-info {
    position: absolute;
    left: 44px;
    top: 4px;
    width: 300px;
    height: 47px;
    .appTitle {
      display: inline-block;
      font-size: 12px;
      vertical-align: middle;
      height: 57px;
      padding-left: 4px;
    }
    img{
      width: 60px;
      max-width: 100%;
      max-height: 60px;
    }
  }

  .card-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 16px;
    padding: 20px 0;
    text-align: center;
    // font-weight: bold;
    height: 30px;
    .el-textarea__inner {
      font-size: 18px;
      padding: 20px 0;
      text-align: center;
      color: #000;
      font-weight: bold;
      height: 50px;
      .el-textarea__inner {
        font-size: 18px;
        font-weight: bold;
        padding: 0px;
        text-align: center;
        border: 1px dotted #ccc;
        font-weight: bold;
        // font-family: "黑体";
      }
    }
    .el-input__count {
      right: 20px;
    }
  }
  .wrapper-content {
    // border: 1px solid #409eff;
    border-radius: 10px;
    // padding: 0 10px;
    // padding: 0 10px 10px 10px;
  }
  .card-tool {
    height: 40px;
    padding-top: 20px;
    background: linear-gradient(to right, #4891ff, #21cfff);
    color: #fff;
    padding-left: 20px;
    .submit-text {
      position: relative;
      top: -10px;
      cursor: pointer;
      width: 60px;
      text-align: center;
    }
    .custom-row {
      .custom-col {
        margin-right: 20px;
        &:first-child,
        &:nth-child(5) {
          margin-right: 40px;
        }
        &:nth-child(2) {
          margin-right: auto;
          margin-top: -10px;
        }
      }
    }
  }
  .card-make-box {
    margin: 0 auto;
    position: absolute;
    width: 100%;
    bottom: 5px;
    top: 60px;
    .bd-le {
      height: 100%;
      overflow-y: auto;
      // overflow: visible;
    }
    .bd-ri {
      position: relative;
      float: right;
      width: 440px;
      background: #fff;
      height: 100%;
      overflow-y: auto;
    }
    .disabled_mask{
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000;
      z-index: 9;
      cursor: not-allowed;
      opacity: .3;
    }
    .fix-box {
      position: absolute;
      left: -15px;
      top: 100px;
    }
    .card-content {
      // font-size: 3mm;
      //font-family: 宋体, SimSun, "STSong";
      // font-family: "Verdana", "宋体";
      position: relative;
      color: #000000;
      width: 794px;
      margin: 0 auto;
    }
  }
  // #preview {
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   right: 0;
  //   bottom: 0;
  //   background: #fff;
  //   overflow: auto;
  //   z-index: 20000;
  //   font-family: "Verdana", "宋体";
  //   color: #000000;
  //   .close {
  //     position: absolute;
  //     right: 20px;
  //     top: 20px;
  //     font-size: 35px;
  //     cursor: pointer;
  //   }
  //   .fill-cont p {
  //     height: 36px;
  //     margin-top: 18px;
  //   }
  // }
  .preview-wrapper {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    z-index: -1;
    // font-family: "Verdana", "宋体";
    color: #000;
    background: #f1f1f1;
    .close {
      border: 1px solid #fff;
      position: fixed;
      margin-top: 10px;
      font-size: 42px;
      right: 30px;
      z-index: 1004;
      cursor: pointer;
      background: #fff;
      border-radius: 25px;
    }
    .close_wait {
      cursor: wait;
    }
    .card-content {
      margin: 0 auto;
      height: 100%;
      position: relative;
    }
    .topic-box {
      overflow: hidden;
      .topic-bd {
        word-break: break-word;
      }
      p.row {
        min-height: 38px;
        line-height: 38px;
        word-spacing: 0;
      }
      p {
        min-height: 38px;
        margin: 0 !important;
      }
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .page-cell {
    //border: solid 1px black;
    background: #fff;
    //height: 1123px;
    padding: 0;
    .position_point {
      position: absolute;
      width: 22px;
      height: 11px;
      background: #000;
    }
    #barcode {
      position: absolute;
      width: 100px;
      height: 50px;
      bottom: 4px;
      z-index: 999;
      right: -53px;
    }
    .left {
      left: 16px;
      top: 25px;
    }
    .top {
      right: 16px;
      top: 25px;
    }
    .bottom {
      bottom: 25px;
      left: 16px;
    }
    .right {
      right: 16px;
      bottom: 25px;
    }
  }

  .ck-content,
  .ck-content.ck-editor__editable_inline,
  .ck-content.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
    // padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .topic-box {
    position: relative;
    // overflow: hidden;
    // margin-top: 10px;
  }

  .topic-th {
    position: relative;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
  .topic-bd {
    position: relative;
    overflow: hidden;
    // border: 1px solid #000 !important;
    border: 1px solid #000 !important;
    .move-h {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #409eff;
      font-size: 20px;
      z-index: 2004;
      cursor: pointer;
    }
    .ck-content {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .ck-content.ck-editor__editable_inline > :last-child {
      margin-bottom: 0;
    }
    .ck-content.ck-editor__editable_inline > :first-child {
      padding-top: 39px;
      margin-top: 0 !important;
    }
  }
  .kfformula {
    vertical-align: middle;
  }
  .move-tips {
    position: absolute;
    left: 101%;
    bottom: 0;
    width: 100px;
  }
  #div1 {
    min-height: 100px;
    width: 100%;
    border: 1px solid #000;
  }
}
#preview-page {
  pointer-events: none !important;
}

#preview-page-wrap{
  .ab-box {
    border: none !important;
  }
}
</style>
